import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Base Instance endpoints
  createBaseInstance: (data) => {
    return AxiosBusiness.post('base-instance', data)
  },

  updateBaseInstance: (baseInstanceId, data) => {
    return AxiosBusiness.put(`base-instance/${baseInstanceId}`, data)
  },

  deleteBaseInstance: (baseInstanceId) => {
    return AxiosBusiness.delete(`base-instance/${baseInstanceId}`)
  },

  getBaseInstance: (baseInstanceId) => {
    return AxiosBusiness.get(`base-instance/${baseInstanceId}`)
  },

  getBaseInstancesByService: (serviceId, params = {}) => {
    return AxiosBusiness.get(`base-instance/service/${serviceId}`, { params })
  },
}
